import Domain from "enums/Domain";
import { azForHost } from "util/envUtils";

function seconds(sec: number) {
    return sec * 1000;
}

/* Externalized strings are loaded during app start, this path needs to know the
 * build number because resources are nested under that directory path when deployed.
 */
const cdnUrl = "";
let stringsDirectory = "strings";
if (cdnUrl) {
    stringsDirectory = cdnUrl + stringsDirectory; //CDN_URL will include the slash.
}

/**
 * Default application configuration. These options will be used
 * in other unknown environments and should be set to match
 * production config so any proxied access to the UI will run
 * against production.
 *
 * URI definitions are handled via separate object properties
 * for the relevant parts of the URI, such that
 * 'https://public-api.us-east-1.inindca.com:8000/api/v1'
 * would be represented as:
 *  {
 *      protocol: 'https',
 *      hostname: 'public-api.us-east-1.inindca.com',
 *      port: '8000',
 *      path: '/api/v1',
 *  }
 *
 * The 'port' and 'path' properties are both optional
 */
export default {
    defaultEnvironment: "mypurecloud.com",
    envName: "pca",
    appName: "interaction-details-ui",
    appVersion: "dev",
    cdnUrl: cdnUrl,
    embeddingOrigin:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : ""),
    stringsDirectory: stringsDirectory, //The location where externalized strings live.
    localLogLevel: "none",
    serverLogLevel: "error",
    serverLogInterval: seconds(2),
    maxServerLogInterval: seconds(30),
    maxServerLogSize: 4000, //default server limit is 5k - this is message limit, not request payload limit, so we scale down a bit.
    defaultLocale: "en-US",
    api: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/api/v1",
        timeout: seconds(30),
    },
    architect: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/architect",
    },
    notifications: {
        protocol: "wss",
        hostname: "PROD_HOST",

        // The maximum interval between the times that our web socket logic will
        // try to reconnect to the backend for push notifications. This is used
        // when an error occurs with the connection and we want to try and
        // reconnect to the backend.
        maxReconnectInterval: seconds(30),
    },
    journey: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/journey",
    },
    journey_micro: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/journey-micro",
    },
    giaTranscript: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/transcript-ui",
    },
    giaTranscriptV2: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/transcript-ui-v2",
    },
    qualityForms: {
        protocol: "https",
        hostname: "PROD_HOST",
        path: "/quality-forms",
    },
};
